export default {
  assessment: {
    id: '',
    nameLocal: '',
    nameEng: '',
  },
  assessments: [],
  processing: false,
  error: null,
  success: null,
}



